import { registerSqlDatasets } from './dataset-utils.ts';
import { sqlDatasetQuery } from 'tio-data/requests/sql-dataset';
import type { Store as StoreService } from '@warp-drive/core';
import type { SqlDataset } from 'tio-data/data/resources/sql-dataset.type';

/**
 * Fetch published SQL-backed datasets (RFC 062) and fill the module registry
 * the synchronous dataset-utils lookups read. Shared by every route that
 * hosts a query-capable reporting surface (tio-admin's reports and dashboards
 * parents, plus tio-employee's admin/reporting) so a fresh-session deep link
 * into any of them sees the same catalog. Only published datasets register —
 * sql-search 404s drafts, and
 * the authoring index intentionally lists them while the pickers must not.
 *
 * Non-fatal on failure: the last-known-good registry is kept, because
 * clearing it would reroute already-open SQL-backed reports/widgets to
 * /api/v2/search mid-session on a transient error. First load starts empty
 * by default anyway.
 */
export async function registerPublishedSqlDatasets(store: StoreService) {
  try {
    const { content } = (await store.request(sqlDatasetQuery())) as {
      content: { data: SqlDataset[] };
    };
    registerSqlDatasets(
      content.data
        .filter((dataset) => dataset.status === 'published')
        .map((dataset) => ({
          slug: dataset.slug,
          label: dataset.label,
          product: dataset.product,
          crossCompanyCapable: dataset.crossCompanyCapable,
        }))
    );
  } catch (error) {
    console.error('Failed to load SQL datasets for the builder surfaces:', error);
  }
}
